module.exports = require("./uz.d.ts");